import React from "react";
import { useSelector } from "react-redux";
import { 
    selectPower,
    selectKSpringOne,
    selectPresetSpringOne,
    selectKSpringTwo,
    selectPositionSpringTwo,
    selectShowIdealCurve,
    selectShowSpringCurve,
    selectDoubleSpring,
} from "../drawingBoard/drawingBoardSlice";
import { 
    kwFromBarAndLpm, 
    barFromKwAndLpmIdeal,
    barFromKAndPresetAndLpmLinear,
    barFromTwoSpringSystem,
} from "./formulae";

const Graphic = () => {
    const power = useSelector(selectPower);
    const kSpringOne = useSelector(selectKSpringOne);
    const presetSpringOne = useSelector(selectPresetSpringOne);
    const kSpringTwo = useSelector(selectKSpringTwo);
    const positionSpringTwo = useSelector(selectPositionSpringTwo);
    const showIdealCurve = useSelector(selectShowIdealCurve);
    const showSpringCurve = useSelector(selectShowSpringCurve);
    const doubleSpring = useSelector(selectDoubleSpring);
    const resolutionLpm = 1;
    const lpmMin = 10;
    const lpmMax = 100;
    const barToY = (bar) => {
        return -bar*(10000/300); 
    }
    const lpmToX = (lpm) => {
        return lpm*100;
    }
    const kwToY = (kw) => {
        return -kw*1000;
    }
    const createPressureCurve = (barCurveFunc, ...theArgs) => {
        let resultAttribute = "";
        for (let i = lpmMin; i <= lpmMax; i+= resolutionLpm){
            resultAttribute += `${lpmToX(i)},${barToY(barCurveFunc(...theArgs,i))} `
        }
        return resultAttribute;
    }

    const createPowerCurve = (barCurveFunc, ...theArgs) => {
        let resultAttribute = "";
        for (let i = lpmMin; i <= lpmMax; i+= resolutionLpm){
            resultAttribute += `${lpmToX(i)},${kwToY(kwFromBarAndLpm(barCurveFunc(...theArgs,i),i))} `
        }
        return resultAttribute;
    }

    return(
        <g>
            {showIdealCurve ? 
                <g>
                    <polyline 
                        points={createPressureCurve(barFromKwAndLpmIdeal, power)}
                        fill="none"
                        stroke="black"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={createPowerCurve(barFromKwAndLpmIdeal, power)}
                        fill="none"
                        stroke="red"
                        strokeWidth={30}
                    />
                </g>
            : null}
            {showSpringCurve && !doubleSpring ? 
                <g>
                    <polyline 
                        points={
                            createPressureCurve(
                                barFromKAndPresetAndLpmLinear, kSpringOne, presetSpringOne
                            )
                        }
                        fill="none"
                        stroke="green"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={
                            createPowerCurve(
                                barFromKAndPresetAndLpmLinear, kSpringOne, presetSpringOne
                            )
                        }
                        fill="none"
                        stroke="magenta"
                        strokeWidth={30}
                    />
                </g>
            : null}
            {showSpringCurve && doubleSpring ? 
                <g>
                    <polyline 
                        points={
                            createPressureCurve(
                                barFromTwoSpringSystem, 
                                kSpringOne, presetSpringOne, kSpringTwo, positionSpringTwo
                            )
                        }
                        fill="none"
                        stroke="green"
                        strokeWidth={30}
                    />
                    <polyline 
                        points={
                            createPowerCurve(
                                barFromTwoSpringSystem, 
                                kSpringOne, presetSpringOne, kSpringTwo, positionSpringTwo
                            )
                        }
                        fill="none"
                        stroke="magenta"
                        strokeWidth={30}
                    />
                </g>
            : null}
        </g>
    );
};

export default Graphic;
